import React from 'react';
import { Link } from 'react-router-dom';
import { Fragment } from 'react';
import { TackIntervalSelectionShape, TackNotificationDetailsShape, WordShape } from '../shapes';
import Waiting from './waiting';
import RecommendedWords from './recommended_words';
import PropTypes from 'prop-types';
import DateMaster from '../stores/utils/date_master';
import WordHeader from './word/header';

const SUPERLATIVES = ['Sweet', 'Nice', 'Yep', 'Well done', 'Correct', 'Bravo', 'Huzzah', 'Yes', 'Golf clap', 'Hallelujah', 'Booyah']
const NEGATIVE_SUPERLATIVES = ['Doh', 'Drat', 'Darn', 'Nah', 'No', 'Hmm', 'Negative', 'Bummer']

export default class TackIntervalSelection extends React.Component {
  static propTypes = {
    word: WordShape,
    tackNotificationDetails: TackNotificationDetailsShape,
    tackIntervalSelection: TackIntervalSelectionShape,
    params: PropTypes.object,
    onMakeTackIntervalSelection: PropTypes.func,
    onResetTackIntervalSelection: PropTypes.func
  }

  state = {
    randomSuperlative: this.randomSuperlative(),
    randomNegativeSuperlative: this.randomNegativeSuperlative()
  }

  componentDidMount() {
    this.props.onResetTackIntervalSelection();
    this.props.onMakeTackIntervalSelection(this.props.params.tackSlug, this.props.params.tackIntervalSelectionMask);
  }

  render() {
    return (
      <div className='word'>
        <WordHeader wordText={ this.props.tackNotificationDetails.get('wordText') } pronunciationFile={ this.props.tackNotificationDetails.get('pronunciationFile') } partOfSpeech={ this.props.tackNotificationDetails.get('partOfSpeech') } />
        { this.renderBody() }
      </div>
    );
  }

  renderBody() {
    if (this.props.tackIntervalSelection.get('loading')) {
      return this.renderCrunching();
    } else if (this.props.tackIntervalSelection.get('isCorrect')) {
      return this.renderCorrect();
    } else if (this.props.tackIntervalSelection.get('error')) {
      return this.renderError();
    } else if (!this.props.tackIntervalSelection.get('isCorrect')){
      return this.renderIncorrect();
    } else {
      return this.renderCrunching();
    }
  }

  renderCrunching() {
    return(
      <div className='item-meta'>
        <Waiting />
      </div>
    );
  }

  renderError() {
    return(
      <div className='row'>
        <div className='error col-sm-12' >
          { `Hmm. ${ this.props.tackIntervalSelection.get('error') }` }
        </div>
        <div className='col-sm-12 action center'>
          <Link to='/tack_board' className='btn btn-dark' data-primary-cta='true'>Oops</Link>
        </div>
      </div>
    )
  }

  renderIncorrect() {
    const definitionList = this.props.word.get('definitions').map((definitionText, i) => { return(<li key={i}>{ definitionText }</li>) });
    return (
      <div className='word'>
        <p>
          { `${ this.state.randomNegativeSuperlative }. That's not quite right.` }
        </p>
        <p>
          &nbsp;<b>{ `${ this.props.tackIntervalSelection.get('correctWordText') }` }</b> means:
        </p>
        <ol className='definition-text'>{ definitionList }</ol>
        { this.renderIncorrectCTA() }
      </div>
    );
  }

  renderIncorrectCTA() {
    if (this.props.tackIntervalSelection.get('isTackDone')) {
      return (
        <div className='col-sm-12 action'>
          <Link to='/tack_board' className='btn btn-outline-secondary' data-primary-cta='false'>Got it</Link>
          <Link to={ `/tacks/${ this.props.tackIntervalSelection.get('correctWordText') }/${ this.props.tackIntervalSelection.get('language') }` } className='btn btn-dark' data-primary-cta='true'>Tack Again</Link>
        </div>
      );
    } else {
      return (
        <Fragment>
          <p className='highlight-sandwich'>
            We're going to send { this.props.word.get('wordText') } to you again in a couple days to
            give you a memory boost.
          </p>
          <div className='col-sm-12 action'>
            <Link to='/tack_board' className='btn btn-dark' data-primary-cta='true'>Thanks!</Link>
          </div>
        </Fragment>
      );
    }
  }

  renderCorrect() {
    return (
      <div className='row'>
        <div className='col-sm-12'>
          <p>
            { `${ this.state.randomSuperlative }! That's the right choice for` } <b>{ `${ this.props.tackIntervalSelection.get('correctWordText') }` }.</b>
          </p>
          { this.renderNextTack() }
          { this.renderCongrats() }
          <RecommendedWords wordText={ this.props.tackNotificationDetails.get('wordText') } recommendedWords={ this.props.tackNotificationDetails.get('recommendedWords') } />
        </div>
        <div className='col-sm-12 action'>
          { this.renderCorrectCTA() }
        </div>
      </div>
    );
  }

  renderCongrats() {
    if (this.props.tackIntervalSelection.get('tackInterval') === 13) {
      return (
        <div className='center secondary-background-blue meta-section'>
          <b>You finished tacking { this.props.tackIntervalSelection.get('correctWordText') }</b>!
        </div>
      )
    } else return null;
  }

  renderNextTack() {
    if (this.props.tackIntervalSelection.get('nextSendDate')) {
      return (
        <p>
          Next Tack: { this.nextTackDate(this.props.tackIntervalSelection.get('nextSendDate')) }
        </p>
      )
    } else return null;
  }

  renderCorrectCTA() {
    if (this.props.tackIntervalSelection.get('isTackDone')) {
      return (
        <Fragment>
          <Link to={ `/tacks/${ this.props.tackIntervalSelection.get('correctWordText') }/${ this.props.tackIntervalSelection.get('language') }` } className='btn btn-outline-secondary' data-primary-cta='false'>Tack Again</Link>
          <Link to='/tack_board' className='btn btn-dark' data-primary-cta='true'>Got it!</Link>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <Link to='/tack_board' className='btn btn-dark' data-primary-cta='true'>Got it!</Link>
        </Fragment>
      );
    }
  }

  randomSuperlative() {
    return SUPERLATIVES[Math.floor(Math.random() * SUPERLATIVES.length)];
  }

  randomNegativeSuperlative() {
    return NEGATIVE_SUPERLATIVES[Math.floor(Math.random() * NEGATIVE_SUPERLATIVES.length)];
  }

  nextTackDate(nextSendDateString) {
    if ((new Date(nextSendDateString)) < (new Date())) {
      return 'Tomorrow';
    } else {
      return DateMaster.format(DateMaster.addDays(nextSendDateString, 1));
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_interval_selection.jsx